import * as React from "react";

import { decimalCalc } from "../../../../../../../../../server/lib/ad-copy/aggregate/common";
import { calcDiffPercent } from "../../../../simulation/common";
import { SellPotential } from "../../../../../../../../../server/models/graph/demand-forecast";

type Props = {
	cpValue: number | undefined;
	initValue: number;
	label: string;
	name: keyof SellPotential | "goal";
	testValue: number | undefined;
};

export const ResultTableRow = React.memo((props: Props) => {
	const { cpValue, initValue, label, name, testValue } = props;

	const diff = cpValue == null ? NaN : calcDiffPercent(initValue, cpValue);

	const diffTestValue = testValue == null ? NaN : calcDiffPercent(cpValue ?? initValue, testValue);

	return (
		<tr>
			<td className={name}>{label}</td>

			{/* 初期値(万個) */}
			<td>{decimalCalc(initValue, 10).toFixed(1)}</td>

			{/* ①実績値 修正後 */}

			{/* 補整値(万個) */}
			<td>{cpValue == null ? "-" : decimalCalc(cpValue, 10).toFixed(1)}</td>

			{/* 補整率(%) */}
			{name === "goal" ? (
				<td />
			) : (
				<td className={diff < 0 ? "minus" : "plus"}>{cpValue == null ? "-" : diff.toFixed(1)}</td>
			)}

			{/* ②テスト品 変数補整後 */}

			{/* 補整値(万個) */}
			<td>{testValue == null ? "-" : decimalCalc(testValue, 10).toFixed(1)}</td>

			{/* 補整率(%) */}
			{name === "goal" ? (
				<td />
			) : (
				<td className={diffTestValue < 0 ? "minus" : "plus"}>
					{isNaN(diffTestValue) ? "-" : diffTestValue.toFixed(1)}
				</td>
			)}
		</tr>
	);
});
